import { MainList } from "@/classes/MainList";
import usersList, { UsersListParams } from "@/getinfo-api/users";
import api from "@/getinfo-api";
import { User as IUser } from "@/api/models/user";
import { uniqBy } from "lodash";

export class UsersListClass extends MainList {
  params: UsersListParams = {
    limit: 30,
    offset: 0
  };

  constructor(params?: UsersListParams, selectedValue?: string | undefined) {
    super();
    this.dataLabel = "users";
    this.params = { ...this.params, ...params };
    this.baseParams = this.params;
    this.method = usersList;
    if (selectedValue) {
      this.singleMethod = () => api.UsersApi.get(selectedValue);
      this.single();
    }
    this.list();
  }

  get users(): Array<IUser> {
    return this.listItems;
  }

  async search(value: string) {
    const firstName: UsersListParams = {
      firstName: value,
      offset: 0,
      limit: 30
    };
    const lastName: UsersListParams = {
      lastName: value,
      offset: 0,
      limit: 30
    };
    const phone: UsersListParams = {
      phone: value,
      offset: 0,
      limit: 30
    };
    const email: UsersListParams = {
      email: value,
      offset: 0,
      limit: 30
    };
    this.isLoading = true;
    this.listItems = [];
    await Promise.allSettled(
      [firstName, lastName, phone, email].map(async params => {
        let { data } = await usersList(params);
        if (data?.users?.length) {
          this.listItems = [...this.listItems, ...data.users];
        }
      })
    );
    this.listItems = uniqBy(this.listItems, "id");
    this.isLoading = false;
  }
}
